import { render } from "./DepositPage.vue?vue&type=template&id=76408053&scoped=true"
import script from "./DepositPage.vue?vue&type=script&lang=js"
export * from "./DepositPage.vue?vue&type=script&lang=js"

import "./DepositPage.vue?vue&type=style&index=0&id=76408053&scoped=true&lang=css"
import "./DepositPage.vue?vue&type=style&index=1&id=76408053&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76408053"]])

export default __exports__